'use client';

import Reviews from './Reviews';
import { Button } from '@get-mosh/msh-shared';
import Heading from 'src/components/Heading/Heading';
import Image from 'next/image';
import Routes from 'src/constants/Routes';
import { trackClick } from 'src/analytics/Events';
import EventNames from 'src/analytics/EventNames';
import commonCopy from '../../data/common.json';
import { Review } from './RewiewsCard';
import { ImageField } from '@prismicio/client';
import classNames from 'classnames';

type ReviewsWrapperProps = {
    title: string;
    image?: ImageField;
    reviews: Review[];
};

const ReviewsWrapper = ({ title, image, reviews }: ReviewsWrapperProps) => {
    const handleReviewsClick = () => {
        trackClick(EventNames.BUTTON_READ_MORE_REVIEWS_CLICKED, {});
    };

    return (
        <div className="container mx-auto pb-4 pt-16 md:pb-0 lg:pt-16">
            <div className="mx-auto flex flex-wrap items-baseline justify-center xl:container lg:items-center">
                <div className="flex w-full flex-wrap justify-center md:w-1/2 md:pr-8 lg:pr-0">
                    <Heading centered={true} tag="p" level="h2">
                        {title}
                    </Heading>
                    <div className="mt-auto hidden md:block">
                        {image?.url ? (
                            <Image
                                src={image.url}
                                alt={image.alt ?? title}
                                width={image.dimensions.width}
                                height={image.dimensions.height}
                            />
                        ) : (
                            <Image
                                src={'/images/icons/draw-customers.png'}
                                alt={title}
                                width={844}
                                height={386}
                            />
                        )}
                    </div>
                </div>
                <div className="my-8 flex w-full flex-wrap md:mt-0 md:h-full md:w-1/2">
                    {reviews.length > 0 && <Reviews reviews={reviews} />}
                    <div
                        className={classNames('block w-full text-center', {
                            hidden: true, // Hiding this while our score is bad https://get-mosh.atlassian.net/browse/MSH-2201
                        })}
                    >
                        <Button
                            as="a"
                            onClick={handleReviewsClick}
                            text={commonCopy.readMoreReviews}
                            href={Routes.REVIEWS}
                            className={
                                'mx-0 mt-8 w-full sm:mx-auto sm:max-w-[320px]'
                            }
                            target={'_blank'}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReviewsWrapper;
